import { makeActionCreator } from '../../../../utilities'
import { PnMedicationConstants } from './pnMedication.constants'

export const setMedicationPNNV = makeActionCreator(
  PnMedicationConstants.SET_MEDICATION_PNNV,
  'medicationPNNV',
  'pnMedication'
)
export const setMedication = makeActionCreator(PnMedicationConstants.SET_MEDICATION, 'medication', 'pnMedication')
export const setMedDose = makeActionCreator(PnMedicationConstants.SET_DOSE, 'dose', 'pnMedication')
export const setMedDoseUnit = makeActionCreator(PnMedicationConstants.SET_DOSE_UNIT, 'doseUnit', 'pnMedication')
export const setMedDoseUnitPNNV = makeActionCreator(
  PnMedicationConstants.SET_DOSE_UNIT_PNNV,
  'doseUnitPNNV',
  'pnMedication'
)
export const setMedRoute = makeActionCreator(PnMedicationConstants.SET_ROUTE, 'route', 'pnMedication')
export const setMedRoutePNNV = makeActionCreator(PnMedicationConstants.SET_ROUTE_PNNV, 'routePNNV', 'pnMedication')
export const setKey = makeActionCreator(PnMedicationConstants.SET_KEY, 'key')
export const resetPnMedicationState = makeActionCreator(PnMedicationConstants.RESET_STATE)
export const setDate = makeActionCreator(PnMedicationConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(PnMedicationConstants.SET_TIME, 'time')
export const setDateTime = makeActionCreator(PnMedicationConstants.SET_DATE_TIME, 'time', 'date')
export const setPTA = makeActionCreator(PnMedicationConstants.SET_PTA, 'pta')
export const addPnMedication = makeActionCreator(PnMedicationConstants.ADD_PN_MEDICATION)
export const savePnMedication = makeActionCreator(PnMedicationConstants.SAVE_PN_MEDICATION)
export const setResponse = makeActionCreator(PnMedicationConstants.SET_RESPONSE, 'apiResponse')
export const setAddMedicationAdministeredData = makeActionCreator(
  PnMedicationConstants.SET_ADD_PN_MEDICATION_DATA,
  'addMedicationAdministeredData'
)
export const deletePnMedication = makeActionCreator(PnMedicationConstants.DELETE_PN_MEDICATION, 'pnMedication')
export const setAddToTimeLine = makeActionCreator(PnMedicationConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(PnMedicationConstants.SET_STATE, 'pnMedicationState')
